import { render, staticRenderFns } from "./UpdateCodeDialog.vue?vue&type=template&id=87fb0280"
import script from "./UpdateCodeDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports